import React, { useState } from 'react';

import DataTable from 'react-data-table-component';

import './PersonalDataTable.css';
import {
  groupsDataColumnsSettings,
  adminPersonalDataColumnsSettings,
  teacherPersonalDataColumnsSettings,
  salaryDataColumnsSettings,
} from '../../../../utils/constants';
import {
  GroupDataTableProps,
  AdminPersonalDataTableProps,
  TeacherPersonalDataTableProps,
  AdminPersonalTableRowData,
  TeacherPersonalTableRowData,
  SalaryDataTableProps,
  GroupTableRowData,
} from '../../../../utils/interfaces';
import AllGroupDataPopup from '../../utility_popups/AllGroupDataPopup/AllGroupDataPopup';
import AllStudentDataPopup from '../../utility_popups/AllStudentDataPopup/AllStudentDataPopup';

const conditionalRowStyles = [
  {
    when: (row: AdminPersonalTableRowData | TeacherPersonalTableRowData) =>
      row.recommended_sum > 700,
    style: {
      backgroundColor: 'rgba(255, 0, 0, 0.3)',
      // color: 'red',
    },
  },
];

const conditionalAdminRowStyles = [
  {
    when: (row: AdminPersonalTableRowData | TeacherPersonalTableRowData) =>
      row.recommended_sum > 700,
    style: {
      backgroundColor: 'rgba(255, 0, 0, 0.3)',
      // color: 'red',
    },
  },
  {
    when: (row: AdminPersonalTableRowData) => row.status['is_student'] == false,
    style: {
      backgroundColor: 'rgba(10, 10, 10, 0.3)',
      color: 'rgba(0, 0, 0, 0.27)',
    },
  },
];

const AdminPersonalDataTable: React.FC<AdminPersonalDataTableProps> = ({
  data,
  apiService,
}) => {
  const [showAllStudentDataPopup, setShowAllStudentDataPopup] = useState(false);
  const [studentId, setStudentId] = useState(0);
  const [studentName, setStudentName] = useState('Имя Неизвестно');
  const handleStudentRowClicked = (row: AdminPersonalTableRowData) => {
    setStudentId(Number(row.id));
    setShowAllStudentDataPopup(true);
    setStudentName(row.name);
  };
  return (
    <div className="personaldatatable__general">
      <DataTable
        className="personaldatatable__data"
        title="Персональные данные"
        data={data}
        columns={adminPersonalDataColumnsSettings}
        pagination
        paginationPerPage={10}
        onRowClicked={handleStudentRowClicked}
        paginationRowsPerPageOptions={[10, 20, 30, 200]}
        conditionalRowStyles={conditionalAdminRowStyles}
        defaultSortFieldId={2}
        defaultSortAsc={true}
      />
      {showAllStudentDataPopup && (
        <AllStudentDataPopup
          onClose={() => setShowAllStudentDataPopup(false)}
          apiService={apiService}
          studentId={studentId}
          studentName={studentName}
        />
      )}
    </div>
  );
};

const TeacherPersonalDataTable: React.FC<TeacherPersonalDataTableProps> = ({
  data,
  apiService,
}) => {
  const [showAllStudentDataPopup, setShowAllStudentDataPopup] = useState(false);
  const [studentId, setStudentId] = useState(0);
  const [studentName, setStudentName] = useState('Имя Неизвестно');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleStudentRowClicked = (row: TeacherPersonalTableRowData) => {
    setStudentId(Number(row.id));
    setShowAllStudentDataPopup(true);
    setStudentName(row.name);
  };
  return (
    <div className="personaldatatable__general">
      <DataTable
        className="personaldatatable__data"
        title="Персональные данные"
        data={data}
        columns={teacherPersonalDataColumnsSettings}
        pagination
        onRowClicked={handleStudentRowClicked}
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 40]}
        conditionalRowStyles={conditionalRowStyles}
        defaultSortFieldId={1}
        defaultSortAsc={true}
      />
      {showAllStudentDataPopup && (
        <AllStudentDataPopup
          onClose={() => setShowAllStudentDataPopup(false)}
          apiService={apiService}
          studentId={studentId}
          studentName={studentName}
        />
      )}
    </div>
  );
};

const GroupDataTable: React.FC<GroupDataTableProps> = ({ data }) => {
  const [showAllGroupDataPopup, setAllGroupDataPopup] = useState(false);
  const [groupName, setGroupName] = useState('');
  const handleGroupRowClicked = (row: GroupTableRowData) => {
    setGroupName(row.name);
    setAllGroupDataPopup(true);
  };
  return (
    <div className="groupdatatable__general">
      <DataTable
        className="groupdatatable__data"
        title="Групповые данные"
        data={data}
        onRowClicked={handleGroupRowClicked}
        columns={groupsDataColumnsSettings}
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20]}
      />
      {showAllGroupDataPopup && (
        <AllGroupDataPopup
          onClose={() => setAllGroupDataPopup(false)}
          groupTitle={groupName}
        />
      )}
    </div>
  );
};

const SalaryDataTable: React.FC<SalaryDataTableProps> = ({ data }) => {
  return (
    <div className="groupdatatable__general">
      <DataTable
        className="groupdatatable__data"
        title="Зарплата"
        data={data}
        columns={salaryDataColumnsSettings}
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10]}
      />
    </div>
  );
};

export {
  AdminPersonalDataTable,
  GroupDataTable,
  TeacherPersonalDataTable,
  SalaryDataTable,
};
